export default function techinicalteamusers(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                techinicalteamuser: action.techinicalteamuser,
            }
        default:
            return state;
    }
}
